<template>
  <aside class="Sidebar menu">
    <transition name="slide">
      <div
        v-if="isPanelOpened"
        class="sidebar-panel"
      >
        <slot></slot>
        <LocaleSwitcher />
      </div>
    </transition>
  </aside>
</template>

<script>
import LocaleSwitcher from "@/components/LocaleSwitcher"

export default {
  components: {
    LocaleSwitcher,
  },

  computed: {
    isPanelOpened () {
      return this.$store.state.isOpenSidebar
    }
  },

  methods: {
    closeSidebarPanel() {
      this.$store.dispatch('toggleSidebar')
    }
  },
}
</script>

<style lang="scss">
.Sidebar {

  .slide-enter-active,
  .slide-leave-active
  {
    transition: transform 0.2s ease;
  }

  .slide-enter,
  .slide-leave-to {
    transform: translateX(-100%);
    transition: all 150ms ease-in 0s
  }

  .sidebar-panel {
    overflow-y: auto;
    background-color: $hightBackground;
    position: relative; // fixed for no collapse the container
    left: 0;
    top: 0;
    height: 100vh;
    z-index: 2;
    padding: 3rem 20px 2rem 20px;
  }

  @include xs {
    .sidebar-panel {
      width: 180px;
    }
  }

  @include sm {
    .sidebar-panel {
      width: 200px;
    }
  }

  @include md {
    .sidebar-panel {
      width: 230px;
    }
  }

  @include lg {
    .sidebar-panel {
      width: 250px;
    }
  }
}
</style>
